/* eslint-disable */
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "@reach/router";
import { useTranslation } from "react-i18next";

import getAccessToken from "./getAccessToken";

const { REACT_APP_API_URL } = process.env;

const UPLOAD_ERROR_KEYS = {
  missing_access_token: ["ehr:upload_error_missing_token", "Tu sesión expiró, volvé a iniciar sesión e intentá de nuevo"],
  no_files: ["ehr:upload_error_no_files", "El archivo no llegó al servidor, intentá de nuevo"],
  unsupported_file_type: ["ehr:upload_error_unsupported_type", "Ese tipo de archivo no está permitido"],
  upload_failed: ["ehr:upload_error_failed", "Ocurrió un error en el servidor al guardar el archivo"],
};

const getUploadErrorMessage = (t, reason) => {
  const [key, defaultText] = UPLOAD_ERROR_KEYS[reason] || [];
  if (key) return t(key, defaultText, { context: "files" });

  return t("ehr:upload_error_unknown", `No se pudieron subir los archivos (${reason})`, {
    context: "files",
    reason,
  });
};

const useUpload = () => {
  const { t } = useTranslation();
  const accessToken = getAccessToken();

  const upload = async (files) => {
    try {
      if (!accessToken.value) {
        throw new Error("missing_access_token");
      }

      const array = Array.from(files);
      const body = new FormData();
      for (const file of array) {
        body.append("files", file);
      }
      const res = await fetch(`${REACT_APP_API_URL}/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken.value}`,
        },
        body,
      });
      // Bug real (auditoría 2026-08-16): res.json() directo tira un
      // SyntaxError crudo ("Unexpected token < in JSON...") si la respuesta
      // no es JSON — un caso real y común: un proxy/gateway rechazando un
      // archivo grande con un 413 y body HTML/texto plano. Ese mensaje
      // crudo no matchea ninguna key de UPLOAD_ERROR_KEYS y el usuario ve
      // el error técnico interpolado en el toast genérico en vez de un
      // mensaje entendible. Mismo patrón defensivo ya usado en
      // hooks/useQuery.js: texto primero, JSON.parse con fallback.
      const text = await res.text();
      let data;
      try {
        data = text ? JSON.parse(text) : null;
      } catch {
        data = null;
      }
      if (!res.ok || !Array.isArray(data) || data.length === 0) {
        throw new Error(data?.message || `upload_failed_${res.status}`);
      }
      return data;
    } catch (error) {
      console.error(error);
      window.notify({
        message: getUploadErrorMessage(t, error.message),
        type: "danger",
        title: "Error",
      });
      return null;
    }
  };

  return upload;
};

export default useUpload;

/* eslint-enable */
